import React, { useState, useEffect } from "react";
import { mmRecordService } from '../../services/api/mmRecord.service';
import { nomService } from '../../services/api/nom.service';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utils } from "../../services/helpers/utils";

export const MMPreauthorizationInvestigations = (props) => {
    const noxe = props.noxe ?? [];
    const tipFisa = props.tipFisa ?? -1;
    const [list, setList] = useState([]);
    const [defaults, setDefaults] = useState([]);
    const [dropdown, setDropdown] = useState([]);
    const [noxeInvestigatii, setNoxeInvestigatii] = useState([]);

    useEffect(() => {
        mmRecordService.getNomInvestigations()
            .then(response => {
                if (response) {
                    setDropdown(response);
                }
            });

        mmRecordService.getNoxesInvestigations()
            .then(response => {
                if (response) {
                    setNoxeInvestigatii(response);
                }
            });

    }, []);

    useEffect(() => {
        if (list.length == 0) {
            setDefaults([]);
        }
        else if (list.length > 0 && dropdown.length > 0) {
            let d = [];
            for (var item in list) {
                let el = utils.findObjectById(dropdown, list[item].idInvestigatie)
                if (el) {
                    d.push(el);
                }
                else {
                    // Pentru diagnoticele care nu sunt active le aduc din baza si le adaug in dropdown
                    if (list[item].idInvestigatie > 0) {
                        nomService.getInvestigationsById({ id: list[item].idInvestigatie })
                            .then(response => {
                                if (response) {
                                    var newlist = [...dropdown];
                                    newlist.push(response);
                                    setDropdown(newlist);
                                }
                            });
                    }
                }
            }
            setDefaults(d);
        }
    }, [list, dropdown]);

    useEffect(() => {
        let newList = [];

        if (noxe.length > 0 && noxeInvestigatii.length > 0) {

            for (let i = 0; i < noxe.length; i++) {
                for (let j = 0; j < noxeInvestigatii.length; j++) {
                    if (noxe[i].idNoxa == noxeInvestigatii[j].idNoxa &&
                        (tipFisa == 4 && noxeInvestigatii[j].angajare == 1 ||
                            tipFisa == 5 && noxeInvestigatii[j].angajare == 1 ||
                            tipFisa == 6 && noxeInvestigatii[j].angajare == 1 ||
                            tipFisa == 7 && noxeInvestigatii[j].angajare == 1 ||
                            tipFisa == 8 && noxeInvestigatii[j].luna0 == 1 ||
                            tipFisa == 0 && noxeInvestigatii[j].luna0 == 1 ||
                            tipFisa == 1 && noxeInvestigatii[j].luna3 == 1 ||
                            tipFisa == 2 && noxeInvestigatii[j].luna6 == 1 ||
                            tipFisa == 3 && noxeInvestigatii[j].luna9 == 1)) {

                            const investigatieExistenta = newList.some(item => item.idInvestigatie === noxeInvestigatii[j].investigatie);

                            if (!investigatieExistenta) {
                                newList.push(
                                    {
                                        idInvestigatie: noxeInvestigatii[j].investigatie,
                                        dataEfectuarii: new Date(),
                                        suplimentar: 0,
                                        statusFinanciar: 0,
                                        statusFacturare: 0,
                                    })
                            }
                    }
                }
            }
        }

        setList(newList);

    }, [noxeInvestigatii, noxe, tipFisa])



    return (
        <fieldset>
            <legend className="pt20 pb5">Investigatii</legend>
            <table className="tbl tbladd mt5 full" data-name="lista_investigatii_noxe">
                <thead>
                    <tr>
                        <th>Nume investigatie</th>
                    </tr>
                </thead>
                <tbody>
                    {list.map((item, index) => (
                        <tr key={index}>
                            <td data-name="investigatie">
                                <DropDownList name="idInvestigatie"
                                    className="w430 greybg"
                                    data={dropdown}
                                    textField="text"
                                    dataItemKey="id"
                                    value={defaults[index]}
                                    disabled={true}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </fieldset>
    );
}